export function parseToAnyObject(jsonString: string): any {
  try {
    // Remplacer les guillemets simples par des guillemets doubles pour un JSON valide
    const validJsonString = jsonString.replace(/'/g, '"');

    // Parser la chaîne JSON en objet
    const parsedObject = JSON.parse(validJsonString);

    return parsedObject;
  } catch (error) {
    console.error('Erreur lors du parsing du JSON:', error);
    return null; // Retourner null en cas d'erreur
  }
}

// Simple parser function to convert string to JSON object




// Helper to extract specific data from parsed object
export function extractProductData(jsonObj: any) {
  if (!jsonObj) return null;

  return {
    attributeId: jsonObj.id,
    attributeCode: jsonObj.code,
    attributeLabel: jsonObj.label,
    position: jsonObj.position,
    options: jsonObj.options?.map((option: any) => ({
      id: option.id,
      label: option.label,
      productIds: option.products,
      sku: option.data?.sku,
      productId: option.data?.product_id,
      price: option.data?.price,
      specialPrice: option.data?.special_price,
      inStock: option.data?.in_stock === 1,
      isPromo: option.data?.is_promo_label === true,
      priceBy100: option.data?.price_by_100,
      baseline: option.data?.baseline
    })) || []
  };
}

// Most robust parser - handles complex nested quotes and escapes
export function parseToJsonUltraRobust(jsonString: string): any {
  try {
    // Use eval in a safe way as a last resort for Python-like strings
    // This is generally not recommended but works for trusted data
    const pythonToJs = jsonString
      .replace(/True/g, 'true')
      .replace(/False/g, 'false')
      .replace(/None/g, 'null');

    // Create a safe evaluation function
    const safeEval = new Function('return ' + pythonToJs);
    return safeEval();
  } catch (error) {
    console.error('Error with ultra-robust parsing:', error);
    throw new Error(`Could not parse the string: ${error.message}`);
  }
}

// Example usage functions
export function processProductAttribute(jsonString: string) {
  let jsonObj;

      console.log('Robust parser failed, trying ultra-robust parser...');
      jsonObj = parseToJsonUltraRobust(jsonString);



  // Extract structured data
  const productData = extractProductData(jsonObj);

  return {
    raw: jsonObj,           // Original parsed JSON
    structured: productData // Cleaned/structured data
  };
}

// Quick test function
export function testParser() {
  const testString = "{'id': '176', 'code': 'capacity_perfume', 'label': 'Contenance', 'options': [{'id': '1706', 'label': '30 ML', 'products': ['9369'], 'data': {'label': '30 ML', 'sku': 'GAU100', 'baseline': 'Eau de Parfum', 'product_id': '9369', 'price': '<span class=\"price\">74,00\\xa0€</span>', 'special_price': '<span class=\"price\">51,00\\xa0€</span>', 'in_stock': 1, 'out_of_stock_label': 'Rupture momentanée', 'merch_label': '', 'is_promo_label': True, 'gift_credit': False, 'price_by_100': 170}}], 'position': '0'}";

  try {
    const result = processProductAttribute(testString);
    console.log('Parsed successfully:', result);
    return result;
  } catch (error) {
    console.error('Test failed:', error);
    return null;
  }
}

// Usage example:
/*
const yourJsonString = "{'id': '176', 'code': 'capacity_perfume', ...}";

// Simple parsing
const jsonObj = parseToJson(yourJsonString);
console.log(jsonObj);

// Or with structured extraction
const result = processProductAttribute(yourJsonString);
console.log(result.structured.options[0].label); // "30 ML"
console.log(result.structured.options[0].inStock); // true
*/
